<template>
  <!-- Fixed background to a deep purple for professional contrast -->
  <v-footer class="pt-10 pb-6 white-text" style="background-color: #4a148c">
    <v-container>
      <v-row>
        <v-col cols="12" md="4" class="mb-8 mb-md-0">
          <router-link :to="{ name: 'HomeView' }" class="text-decoration-none">
            <!-- Changed title to white for maximum visibility -->
            <h2 class="text-h5 font-weight-bold mb-4 white--text">
              Happy Harbour
            </h2>
          </router-link>

          <div class="subtitle-2 grey--text text--lighten-3 mb-6">
            Crafting unforgettable celebrations for you and your loved ones.
          </div>

          <div class="d-flex align-center mb-3">
            <v-icon small color="white" class="mr-3"> mdi-phone </v-icon>
            <a
              href="tel:+919686411733"
              class="font-weight-bold white--text hover-link"
            >
              +91 9686 411 733
            </a>
          </div>

          <div class="d-flex align-center mb-6">
            <v-icon small color="white" class="mr-3">mdi-email</v-icon>
            <a
              href="mailto:happyharbourofficial@gmail.com"
              class="white--text hover-link"
            >
              happyharbourofficial@gmail.com
            </a>
          </div>

          <v-btn
            outlined
            color="white"
            class="text-capitalize rounded-lg white--text"
            @click="goSocial"
          >
            <v-icon left color="pink">mdi-instagram</v-icon>
            Follow on Instagram
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="2" class="mb-8 mb-sm-0">
          <div
            class="text-uppercase subtitle-2 font-weight-bold white--text text--lighten-4 mb-4"
          >
            Explore
          </div>
          <div class="d-flex flex-column gap-2">
            <router-link
              v-for="link in exploreLinks"
              :key="link.text"
              :to="link.to"
              class="grey--text text--lighten-3 hover-link"
            >
              {{ link.text }}
            </router-link>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="2" class="mb-8 mb-sm-0">
          <div
            class="text-uppercase subtitle-2 font-weight-bold white--text text--lighten-4 mb-4"
          >
            Legal
          </div>
          <div class="d-flex flex-column gap-2">
            <router-link
              v-for="link in legalLinks"
              :key="link.text"
              :to="link.to"
              class="grey--text text--lighten-3 hover-link"
            >
              {{ link.text }}
            </router-link>
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <div
            class="text-uppercase subtitle-2 font-weight-bold white--text text--lighten-4 mb-4"
          >
            Our Locations
          </div>

          <div class="mb-4">
            <div class="font-weight-bold white--text mb-1">RR Nagar</div>
            <div class="caption grey--text text--lighten-3">
              4th Floor, Saphire, Opp RNSIT, Uttarahalli Main Rd, Channasandra,
              Bengaluru, 560098
            </div>
          </div>

        </v-col>
      </v-row>

      <v-divider class="purple lighten-2 my-8" style="opacity: 0.2"></v-divider>

      <div class="text-center caption grey--text text--lighten-2">
        &copy; {{ new Date().getFullYear() }} Happy Harbour Enterprises. All
        Rights Reserved.
      </div>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      exploreLinks: [
        {
          text: "Reviews",
          to: { name: "HomeView", hash: "#customer-reviews" },
        },
        { text: "Our Spaces", to: { name: "HomeView", hash: "#our-space" } },
        { text: "Contact Us", to: { name: "HomeView", hash: "#contact-us" } },
        { text: "Book Now", to: { name: "BookNow" } },
      ],
      legalLinks: [
        { text: "Terms & Conditions", to: { name: "TermsAndConditionsView" } },
        { text: "Refund Policy", to: { name: "RefundPolicyView" } },
        { text: "Privacy Policy", to: { name: "PrivacyPolicyView" } },
      ],
    };
  },
  methods: {
    goSocial() {
      window.open("https://www.instagram.com/happyharbour.in", "_blank");
    },
  },
};
</script>

<style scoped>
/* Helper class for vertical spacing between links */
.gap-2 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Hover effect for links */
.hover-link {
  text-decoration: none;
}

.hover-link:hover {
  text-decoration: underline;
}
</style>
